import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { AlertService } from 'ngx-alerts';
import { NgxSpinnerService } from 'ngx-spinner';
import { DlaService } from 'src/app/shared/dla.service';
import { ReplyMailComponent } from '../reply-mail/reply-mail.component';
import { SendMailFacilitatorComponent } from '../send-mail-facilitator/send-mail-facilitator.component';
import { SendMailComponent } from '../send-mail/send-mail.component';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.css']
})
export class MessageComponent implements OnInit {
  mainPageTitle = 'Message';
  messages: any[];
  userinfo: any;

  constructor(
    private spinner: NgxSpinnerService,
    private alertService: AlertService,
    private dialog: MatDialog,
    private dlaService: DlaService
  ) { }

  ngOnInit(): void {
    this.loadScripts();
    this.userinfo = JSON.parse(localStorage.getItem('dla_student'));
    //console.log(this.userinfo);

    this.getMessages();
  }

  getMessages() {
    this.spinner.show();
    this.dlaService.getInbox(this.userinfo.user_id).subscribe(
      (data: any) => {
        this.spinner.hide();
        const error: boolean = data.error;
        if (!error) {
          console.log(data);
          this.messages = data;
        } else {
          this.alertService.danger(data.message);
        }
      },
      error => {
        this.spinner.hide();
        this.alertService.danger('An error occurred, Please try again');
      }
    );
  }

  // onClick(data: any) {
  //   console.log(data);
  // }

  onClick(data: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.disableClose = true;
    dialogConfig.width = '75%';
    dialogConfig.data = { data: data, userinfo: this.userinfo };
    this.dialog
      .open(ReplyMailComponent, dialogConfig)
      .afterClosed()
      .subscribe(res => {
        console.log('Returend here');
        this.getMessages();
        // let currentUrl = this.router.url;
        // this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        // this.router.onSameUrlNavigation = 'reload';
        // this.router.navigate([currentUrl]);
      });
  }


  messageToStudent() {

    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.disableClose = true;
    dialogConfig.width = '75%';
    dialogConfig.data = { userinfo: this.userinfo, type: 'student' };
    this.dialog
      .open(SendMailComponent, dialogConfig)
      .afterClosed()
      .subscribe(res => {
        console.log('Returend here');
        this.getMessages();
        // let currentUrl = this.router.url;
        // this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        // this.router.onSameUrlNavigation = 'reload';
        // this.router.navigate([currentUrl]);
      });
  }

  messageToFacilitator() {

    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.disableClose = true;
    dialogConfig.width = '75%';
    dialogConfig.data = { userinfo: this.userinfo, type: 'facilitator' };
    this.dialog
      .open(SendMailComponent, dialogConfig)
      .afterClosed()
      .subscribe(res => {
        console.log('Returend here');
        this.getMessages();
        // let currentUrl = this.router.url;
        // this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        // this.router.onSameUrlNavigation = 'reload';
        // this.router.navigate([currentUrl]);
      });
  }



  loadScripts() {
    const dynamicScripts = [
      'assets/js/vendor/jquery-1.11.3.min.js',
      'assets/js/bootstrap.min.js',
      'assets/js/wow.min.js',
      'assets/js/jquery-price-slider.js',
      'assets/js/jquery.meanmenu.js',
      'assets/js/owl.carousel.min.js',
      'assets/js/jquery.sticky.js',
      'assets/js/jquery.scrollUp.min.js',
      'assets/js/scrollbar/jquery.mCustomScrollbar.concat.min.js',
      'assets/js/scrollbar/mCustomScrollbar-active.js',
      'assets/js/metisMenu/metisMenu.min.js',
      'assets/js/metisMenu/metisMenu-active.js',
      // 'assets/js/morrisjs/raphael-min.js',
      // 'assets/js/morrisjs/morris.js',
      // 'assets/js/morrisjs/morris-active.js',
      'assets/js/sparkline/jquery.sparkline.min.js',
      'assets/js/sparkline/jquery.charts-sparkline.js',
      'assets/js/calendar/moment.min.js',
      'assets/js/calendar/fullcalendar.min.js',
      'assets/js/calendar/fullcalendar-active.js',
      'assets/js/plugins.js',
      'assets/js/main.js'
    ];
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < dynamicScripts.length; i++) {
      const node = document.createElement('script');
      node.src = dynamicScripts[i];
      node.type = 'text/javascript';
      node.async = false;
      node.charset = 'utf-8';
      document.getElementsByTagName('head')[0].appendChild(node);
    }
  }

}
